/*
 * Edit Management Point List Tab modal
 */

import { WithTranslation, withTranslation } from 'react-i18next';
import {
    toggleEditMeasurementPointTabModal,
    updateMeasurementPointListTab
} from '../../actions/manageMeasurementPointListsActions';

import { EditMeasurementPointListTabForm } from './EditMeasurementPointListTabForm';
import { WithCommonModal } from '../common/WithCommonModal';
import { connect } from 'react-redux';
import { initialMeasurementPointTab } from '../../reducers/initialState';
import { selectIsLoading } from '../../reducers/commonReducers';
import { IinitialState } from '../../reducers';
import { Isubcategory } from '../../models';
import { FormUtil } from '../common/FormUtil';

interface Iprops {
    colorButton: string;
    isCustomerView: boolean;
}

const mapStateToProps = (
    state: IinitialState,
    ownProps: Iprops & WithTranslation
) => {
    const selectedMPL =
        state.manageMeasurementPointLists.selectedMeasurementPointList;
    const selectedTab =
        selectedMPL.measurementPointTabs.find(
            tab => tab.id === state.manageMeasurementPointLists.selectedTabID
        ) || initialMeasurementPointTab;

    const allSubcategories = state.productInfo.subcategories;
    const filteredSubcategories = selectedMPL.mainCategoryID
        ? Object.values(allSubcategories).filter(
              (sc: Isubcategory) =>
                  sc.mainCategoryID === selectedMPL.mainCategoryID
          )
        : Object.values(allSubcategories);
    const subcategoryOptions = FormUtil.convertToOptions(filteredSubcategories);

    return {
        title: ownProps.t('editTab'),
        className: 'edit-tab',
        secondModal: true,
        user: state.user,
        loading: selectIsLoading(state),
        show:
            state.manageMeasurementPointLists.showEditMeasurementPointTabModal,
        selectedMeasurementPointList: selectedMPL,
        selectedTab,
        subcategoryOptions
    };
};

export const EditMeasurementPointListTabModal = withTranslation(
    'manageMeasurementPointLists'
)(
    connect(mapStateToProps, {
        onHide: toggleEditMeasurementPointTabModal,
        toggleModal: toggleEditMeasurementPointTabModal,
        updateMeasurementPointListTab
    })(WithCommonModal(EditMeasurementPointListTabForm))
);
